'use strict';

var util = require('../../util/property-util');
var nocUtil = require('../../util/noc-util');
var messageDiscriptors = require('../../util/messageDiscriptors');

module.exports = /*@ngInject*/ ["$scope", "AuthenticationFactory", "$filter", "TimeZoneFactory", function ($scope, AuthenticationFactory, $filter, TimeZoneFactory) {
    var ex = this;

    ex.parent = $scope.$parent.inf;

    var init = function () {
        "use strict";
        ex.selectedCsvMessage = undefined;
        ex.csvExports = messageDiscriptors.getCsvExports();
    };

    ex.createExportUrl = function () {
        if (util.isDefined(ex.selectedCsvMessage)) {
            var trainData = ex.parent.trainData;

            var period = TimeZoneFactory.formatUtcToBackendPeriod(trainData.from, trainData.to);

            var object = {
                'trainId': trainData.relativeTrainId,
                'projectId': trainData.projectId,
                'from': period.start,
                'to': period.end
            };
            if (util.isDefined(AuthenticationFactory.getUser().token)) {
                object.token = AuthenticationFactory.getUser().token;
            }
            var url = nocUtil.createCsvUrlPeriod(ex.selectedCsvMessage.type, object);
            window.location = url.replace(/[+]/g,'%2B');
        }
    };


    init();
}];